var React = require('react');

function IconInfo (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#e5e5e5","fillRule":"nonzero","cx":"7","cy":"7","r":"7","key":0}),React.createElement("path",{"d":"M6.507 4.207A.675.675 0 0 1 7.002 4c.192 0 .357.069.495.207a.675.675 0 0 1 .207.495.675.675 0 0 1-.207.495.675.675 0 0 1-.495.207.675.675 0 0 1-.495-.207.675.675 0 0 1-.207-.495c0-.192.069-.357.207-.495zM6.444 6.097h1.125v3.78H6.444z","fill":"#424242","key":1})]);
}

IconInfo.defaultProps = {"width":"14","height":"14"};

module.exports = IconInfo;

IconInfo.default = IconInfo;
